import { render, staticRenderFns } from "./RegistrarVendedor.vue?vue&type=template&id=03f15508&scoped=true&"
import script from "./RegistrarVendedor.vue?vue&type=script&lang=js&"
export * from "./RegistrarVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f15508",
  null
  
)

export default component.exports